import { useNavigate } from 'react-router';
export { aboutHandle as handle } from '../routeMetadata';
import { useRef } from 'react';
import { Button } from '../components/Button';
import { useOrderRoute } from '../contexts/OrderContext';

export default function About() {
  const navigate = useNavigate();
  const orderRoute = useOrderRoute();
  const signupRef = useRef<HTMLFormElement | null>(null);

  const handleOrderClick = () => navigate(orderRoute);
  const handleContactClick = () => navigate('/contact');

  // const handleSignupScroll = () => {
  //   signupRef.current?.scrollIntoView({ behavior: "smooth" });
  // };

  return (
    <main className="min-h-screen pb-16" style={{ background: 'linear-gradient(180deg, #efece6 0%, #f8fafc 100%)' }}>
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8 text-center text-blue-900 drop-shadow-sm tracking-tight">About Bidet New York</h1>
        <div className="bg-white/90 rounded-2xl shadow-xl p-8 mb-10 border border-blue-100">
          <p className="mb-6 text-lg text-gray-800 text-center leading-relaxed">
            <b>Bidet New York</b>
            {' '}
            provides professional bidet installation services for homes and businesses across NYC. We are your trusted partner for modern, affordable, and hassle-free bidet installation. Our team handles everything—from helping you choose the right bidet for your needs and budget, to fast, clean installation, and friendly support. Whether you’re new to bidets or looking to upgrade, we make the process simple and stress-free. We believe every New Yorker deserves a cleaner, more comfortable, and eco-friendly bathroom experience—without the confusion or high costs.{' '}
            <Button type="button" variant="text" className="text-blue-700 underline hover:text-blue-900 font-semibold bg-transparent border-none p-0 m-0 cursor-pointer" onClick={handleOrderClick}>Order a bidet today</Button>
            {' '}
            and experience the difference.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-[#e6f2fa] rounded-xl p-7 shadow border border-blue-100 flex flex-col">
            <h2 className="text-2xl font-bold mb-4 text-blue-900 tracking-tight">Our Mission</h2>
            <p className="mb-0 text-gray-800 leading-relaxed">Our mission is to get a bidet into every bathroom in New York. We’re here to help New Yorkers discover the benefits of bidets and make it easy to get one installed quickly, affordably, and with outstanding customer service.</p>
          </div>
          <div className="bg-[#e6f2fa] rounded-xl p-7 shadow border border-blue-100 flex flex-col">
            <h2 className="text-2xl font-bold mb-4 text-blue-900 tracking-tight">Why Choose a Bidet?</h2>
            <ul className="list-disc pl-6 text-gray-800 space-y-2">
              <li>
                <b>Superior Cleanliness:</b>
                {' '}
                Bidets provide a much more thorough clean than toilet paper alone.
              </li>
              <li>
                <b>Comfort:</b>
                {' '}
                Gentle water is soothing and reduces irritation.
              </li>
              <li>
                <b>Cost Savings:</b>
                {' '}
                Use less toilet paper and save money over time.
              </li>
              <li>
                <b>Eco-Friendly:</b>
                {' '}
                Reduce paper waste and help the environment.
              </li>
              <li>
                <b>Easy Installation:</b>
                {' '}
                Most bidets can be installed on your existing toilet—no major plumbing or renovations required.
              </li>
            </ul>
          </div>
        </div>
        <div className="bg-white/90 rounded-2xl shadow-xl p-8 mb-10 border border-blue-100">
          <h2 className="text-2xl font-bold mb-4 text-blue-900 tracking-tight">Why New Yorkers Love Us</h2>
          <ul className="list-disc pl-6 text-gray-800 space-y-2 mb-6">
            <li>
              <b>Local Experts:</b>
              {' '}
              We’re a small collective of New Yorkers who are passionate about bidets and great service.
            </li>
            <li>
              <b>Personalized Recommendations:</b>
              {' '}
              We help you find the right bidet for your space and lifestyle.
            </li>
            <li>
              <b>Transparent Pricing:</b>
              {' '}
              No hidden fees—just honest, upfront quotes.
            </li>
            <li>
              <b>Fast, Friendly Service:</b>
              {' '}
              We respect your time and your home.
            </li>
          </ul>
        </div>
        <div className="bg-[#e6f2fa] rounded-xl p-8 mb-10 border border-blue-100">
          <h2 className="text-2xl font-bold mb-4 text-blue-900 tracking-tight">Who We Are</h2>
          <p className="mb-6 text-gray-800 leading-relaxed">We’re a team of New Yorkers who believe everyone should have access to the comfort and cleanliness of a bidet. We started Bidet New York because we were surprised by how few people in the city had experienced the benefits of bidets, and how confusing or intimidating the process could seem. Our goal is to make it easy, affordable, and enjoyable for everyone.</p>
          <p className="mb-6 text-gray-800 leading-relaxed">
            <b>Fully insured and trustworthy:</b>
            {' '}
            All our installers are highly reputable—most are engineers or very technically savvy professionals. We run background checks on every team member and pride ourselves on being a close-knit, reliable group you can trust in your home.
          </p>
          <p className="mb-6 text-gray-800 leading-relaxed">
            Want to see what we're up to?{' '}
            <a href="https://instagram.com/bidetny" target="_blank" rel="noopener noreferrer" className="text-pink-600 underline hover:text-pink-800 font-semibold">Follow us on Instagram</a>
            {' '}
            for updates, tips, and a peek behind the scenes.
          </p>
        </div>
        <div className="bg-white/90 rounded-2xl shadow-xl p-8 mb-10 text-center border border-blue-100">
          <h2 className="text-2xl font-bold mb-4 text-blue-900 tracking-tight">Ready to Upgrade?</h2>
          <p className="mb-6 text-gray-800 leading-relaxed">
            If you’re curious about bidets or ready to schedule an installation,
            {' '}
            <Button type="button" variant="text" className="text-blue-700 underline hover:text-blue-900 font-semibold bg-transparent border-none p-0 m-0 cursor-pointer" onClick={handleOrderClick}>order a bidet</Button>
            {' '}
            today. We’re happy to answer your questions and help you get started!
          </p>
        </div>
      </div>
    </main>
  );
}
